import React, { Component } from 'react'
import { connect } from 'react-redux'
import { logout, hackathon,infoQ, invite } from '../actions/userActions'
import { stripe, transactionsListener, payWithTweet, promocode  } from '../actions/paymentActions'
import {Redirect, Link} from 'react-router-dom'
import StripeCheckout from 'react-stripe-checkout';
import stripeLogo from './assets/img/stripe.png'
import { config } from '../config'
import $ from 'jquery'

@connect((store)=>{
  return {
    auth: store.user.auth,
    userData: store.user.userData,
    hackaton: store.user.userData.photoURL ? JSON.parse(store.user.userData.photoURL).hackaton : 'false',
    infoq: store.user.userData.photoURL ? JSON.parse(store.user.userData.photoURL).infoQ : 'false',
    infoQSuccess: store.user.infoQSuccess,
    infoQError: store.user.infoQError,
    hackatonProgress: store.user.hackatonProgress,
    paymentStripeProgress: store.payment.paymentStripeProgress,
    paymentStripeError: store.payment.paymentStripeError,
    paymentStripeSuccess: store.payment.paymentStripeSuccess,
    transactions: store.payment.transactions,
    transactionsProgress: store.payment.transactionsProgress,
    promocodeError: store.payment.promocodeError,
    promocodeProgress: store.payment.promocodeProgress,
    promocodeSuccess: store.payment.promocodeSuccess,
    inviteError: store.user.inviteError,
    inviteProgress: store.user.inviteProgress,
    inviteSuccess: store.user.inviteSuccess
  } 
})
class Dashboard extends Component {

  state = {
    amount: 10,
    pwtCount: 0
  }

  componentWillMount() {
    this.props.dispatch(transactionsListener(this.props.userData.uid))
  }


  componentDidMount() {

      window.addEventListener("message", function(e) {
        if(e.data=='shared'){
          const count = this.state.pwtCount + 1
          this.setState({pwtCount:count})
          if (this.state.pwtCount === 1){
            this.props.dispatch(payWithTweet(this.props.userData.uid, this.props.userData.displayName, this.props.userData.email))
          }
        }

    }.bind(this), false);

  }

  
  handleLogout = () => {
    this.props.dispatch(logout())
  }

  handleAmount = (e) => {
   this.setState({amount:e.target.value})
  }

  handleInvite = (e) => {
    this.props.dispatch(invite(this.invitee.value, this.props.userData.displayName))
   }

  onToken = (token) => {
    let finalObject = {...token, amount: this.state.amount * 100, userId: this.props.userData.uid, name: this.props.userData.displayName, type: 'registration' }
    this.props.dispatch(stripe(finalObject))
  }

  handleCode = (e) =>{
    e.preventDefault()
    this.props.dispatch(promocode(this.props.userData.uid, this.props.userData.displayName, this.props.userData.email,this.code.value))
  }

  handleHackathon = (e) =>{
    this.props.dispatch(hackathon(this.props.userData))
  }

  handleInfoQ = (e) =>{
    e.preventDefault()
    if (e.target.value == 'yes'){
      this.props.dispatch(infoQ(this.props.userData, 'true'))
    }else{
      this.props.dispatch(infoQ(this.props.userData, 'false'))
    }
  }

  render() {

    if(this.props.paymentStripeProgress || this.props.transactionsProgress || this.props.hackatonProgress){
      return (
      <section className="section-form color-1">
      <div className="loader"></div>
      </section>)
    }

    if(this.props.transactions && this.props.transactions[0] && this.props.transactions[0].charge == 'INFOQ' && this.props.infoq == undefined && (!this.props.infoQSuccess || !this.props.infoQError) ){
      return(
      <section className="section-form color-1">
      <div>
      <h3 style={{fontWeight: '400',fontSize: '18px',color: 'rgba(255, 255, 255, 0.59)'}} 
      className="section-subtitle">Do you want to be part of the InfoQ Architects Newsletter?
      <br/></h3>
      <h3 style={{fontWeight: '400',fontSize: '14px',color: 'rgba(255, 255, 255, 0.4)'}} 
      className="section-subtitle">The InfoQ Architects' <a href="https://www.infoq.com/architects-newsletter" target="_blank">Newsletter</a> is your monthly guide to all the topics, technologies and techniques that every professional or aspiring software architect needs to know about.
      <br/></h3>
      
      <button className="btn-register" value="yes"onClick={this.handleInfoQ} >Yes, please</button>&nbsp;
      <button className="btn-register" value="no" onClick={this.handleInfoQ} >No, thanks</button>
      </div>
      </section>)
    }

    if(this.props.transactions.length > 0 || this.props.paymentStripeSuccess){
      $(".paytweet").empty();
    return (
      <section className="section-form color-1">
      <h1 className="section-title">You are all set!</h1>
      <h3 style={{fontWeight: '400',fontSize: '18px',color: 'rgba(255, 255, 255, 0.59)'}} 
            className="section-subtitle">
            An e-mail with event access details has been sent to <strong>{this.props.userData.email}</strong><br/><br/>
            If you did not receive the e-mail or lost it, please <a target="_blank" href={`${config.crowdcast}?email=${this.props.userData.email}`}>login</a> at the Crowdcast event page.
            </h3>
            {this.props.hackaton =='true' ? 
              <h3 style={{fontWeight: '400',fontSize: '18px',color: 'rgba(255, 255, 255, 0.59)'}} 
              className="section-subtitle">You should receive an e-mail with next steps for the Hackathon competition.
              </h3>:
              null
              }
            <hr className="style1"/>
              
            <h3 style={{fontWeight: '400',fontSize: '18px',color: 'rgba(255, 255, 255, 0.59)'}} 
              className="section-subtitle">Included in your ticket is one free pass for a friend. Enter their email below to grant a free ticket:</h3>
              {this.props.inviteError ? <p> Sorry, there was an error sending the email :(</p> : null}
              {this.props.inviteProgress ?
                <div className="loader"></div> : !this.props.inviteSuccess ?
                <form onSubmit={this.handleInvite}>
                <div className="form-invite promo-center"><input className="form-input promo-center-in" placeholder="E-mail" required type="email" ref={(invitee) => this.invitee = invitee}/></div>
                <br/><button className="btn-register" type="submit" >Give free access</button>
                </form> : <p> Invitation sent!</p> 
                }
        
            {this.props.hackaton == 'false' ?
              <div><hr className="style1"/> 
              <h3 style={{fontWeight: '400',fontSize: '18px',color: 'rgba(255, 255, 255, 0.59)'}} 
              className="section-subtitle">You are currently not participating in the Hackathon. To sign up click below:
              <br/><button className="btn-register" onClick={this.handleHackathon} >Sign up for the Hackathon</button>
              </h3></div>:
              null
              }
  
            <br/><br/>
            <h3 style={{fontWeight: '400',fontSize: '14px',color: 'rgba(255, 255, 255, 0.49)'}}><Link to="/" onClick={this.handleLogout}>
            Sign out</Link> ({this.props.userData.email})</h3>
            <br/>

      </section>)
    }
    
    return (
      <section className="section-form color-1">
          <h1 className="section-title">You are almost there!</h1>
          {this.props.paymentStripeError ? <p> Sorry, we had problems processing your payment!</p> : null}
          <h3 style={{fontWeight: '400',fontSize: '18px',color: 'rgba(255, 255, 255, 0.59)'}} 
            className="section-subtitle">All ticket sales go towards an alliance of programming <strong>non-profits</strong>. Not in a position to donate? 
            Attend for free by sharing on social media, to help find more donors.
            </h3><br/>
          <h3 style={{fontWeight: '600',fontSize: '20px',color: 'rgba(255, 255, 255, 0.59)'}} 
            className="section-subtitle">Please select a participation method below:</h3><br/>
      
      <h3 className="donationsTitle"> U.S Dollar Donation </h3>
      <div style={{fontWeight: '400',fontSize: '14px',color: 'rgba(255, 255, 255, 0.2)',margin:'6px'}}>Amount ($)</div>
      <div className="form-amount"><input className="form-input amount-center" required type="number" min="1" step="any" onChange={this.handleAmount} defaultValue={10.00}/></div>
      <StripeCheckout token={this.onToken} image={stripeLogo} 
      amount={this.state.amount*100} email={this.props.userData.email} name="hack.summit() 2018" token={this.onToken} stripeKey={config.stripeKey}>
      <button className="btn-register btn btn-primary">Donate</button></StripeCheckout>
      
      <hr className="style1"/>
      <h3 className="donationsTitle"> Cryptocurrency Donation </h3>
      <div style={{fontWeight: '400',fontSize: '14px',color: 'rgba(255, 255, 255, 0.5)',margin:'6px'}}>
      This page will update when a crypto donation is confirmed (may take several minutes)
      </div>
      <a href={`${config.backend}/coinbase-charge?email=${this.props.userData.email}`} target="_blank">
      <button type="submit" className="btn-register btn btn-primary">Donate</button></a><br/>
      <div>
</div>

      <hr className="style1"/>
      <h3 className="donationsTitle">Share on Social Media </h3>
      <div style={{fontWeight: '400',fontSize: '14px',color: 'rgba(255, 255, 255, 0.5)',margin:'6px'}}>
      Not in a position to donate?  Attend for free by sharing on social media, to help find more donors.
      </div><br/>
      <div className="paytweet">
      <iframe src="https://hacksummit2018-stage.firebaseapp.com" scrolling="no" style={{overflow: 'hidden'}} height="33px" frameBorder="0"></iframe>
      <br/>
      </div>
      <hr className="style1"/>
      <h3 className="donationsTitle">Promo Code</h3>
      <div style={{fontWeight: '400',fontSize: '14px',color: 'rgba(255, 255, 255, 0.5)',margin:'6px'}}>
      Use this option if you've received a code from a partner
      </div>
      {this.props.promocodeError ? <p> Sorry, this is an invalid code!</p> : null}
      {this.props.promocodeProgress ?
      <div className="loader"></div> :
       <form onSubmit={this.handleCode}>
       <br/>
       <div className="form-amount promo-center"><input className="form-input promo-center-in" placeholder="code" required type="text" ref={(code) => this.code = code}/></div>
       <button type="submit" className="btn-register btn btn-primary">Validate</button>
       </form>
      }

      <hr className="style1"/>
        <h3 style={{fontWeight: '400',fontSize: '14px',color: 'rgba(255, 255, 255, 0.49)'}}><Link to="/" onClick={this.handleLogout}>
            Sign out</Link> ({this.props.userData.email})</h3>

      </section>
    );
  }
}

export default Dashboard;



// WEBPACK FOOTER //
// ./src/components/Dashboard.js